import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IVideoTutorial } from "../../../Pages/VideoPage/IVideoTutorial";

export const AddVideoTutorialSlice = createSlice({
    name: "AddVideoTutorialSlice",
    initialState: {} as IReduxState<IVideoTutorial>,
    reducers: {
        addVideoTutorial: (state, action) => {
            state.isLoading = true;
        },
        successaddVideoTutorial: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureaddVideoTutorial: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearAddVideoTutorialResponse: (state) => {
            state.data = {};
        },
    },
});

export const {
    failureaddVideoTutorial,
    addVideoTutorial,
    successaddVideoTutorial,
    clearAddVideoTutorialResponse,
} = AddVideoTutorialSlice.actions;

export default AddVideoTutorialSlice.reducer;
